<style lang="scss" scoped>
.stepOne {
  background-color: #ebf6ff;
  border: 1px dashed #7bbcff;
  height: 434px;
  width: 674px;
  margin: 30px auto;
  .el-progress {
    width: 60%;
    margin: 0 auto;
  }
}
#checkVideo {
  margin: 15px;
  height: 220px;
  ::v-deep video {
    width: 50%;
    height: 100%;
    // height: 50%;
  }
}
.status {
  background: white;
  border-radius: 10px;
  width: 250px;
  height: 90px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 40px;
    font-weight: bold;
    margin-right: 4px;
  }
  span {
    display: inline-block;
  }
  &.success {
    background-color: rgb(139, 212, 162);
    color: green;
  }
  &.error {
    background-color: rgb(231, 162, 162);
    color: red;
  }
}
.statusWrapper {
  padding-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
<template>
  <div class="stepOne">
    <div id="checkVideo"></div>
    <el-select @change="handleVideoDeviceChange" v-model="currentDevice" placeholder="请选择摄像头">
      <el-option
        v-for="(item, index) in devices"
        :key="index"
        :label="item.label"
        :value="item.deviceId"
      ></el-option>
    </el-select>
    <!-- <p>{{statusTip}}</p> -->
    <div class="statusWrapper">
      <div v-if="devices&&devices.length&&!videoError" class="success status">
        <i class="el-icon-success"></i>
        <span>{{statusTip}}</span>
      </div>
      <div v-else class="error status">
        <i class="el-icon-error"></i>
        <span>{{statusTip}}</span>
      </div>
    </div>
  </div>
</template>
<script>
// import recordMp4 from '../../../mixins/recordMp4';
import Media from '../../../utils/Media';

export default {
  data() {
    return {
      devices: null,
      currentDevice: '',
      options: {
        video: {
          width: 1080,
          height: 720,
          frameRate: 15,
          deviceId: 'default',
        },
        streamSource: 'camera',
        audio: false,
        previewBox: 'checkVideo',
      },
      videoError: false,
      videoMedia: null,
      isActive: parseInt(this.$route.params.step, 10) === 2,
    };
  },
  methods: {
    start(noupdate) {
      if (!this.videoMedia) this.videoMedia = new Media(this.options);
      this.$emit('videoCheckStart');
      this.videoMedia.start().then((stream) => {
        if (stream) {
          this.$emit('videoReady');
          if (!noupdate) this.updateDeviceList();
          navigator.mediaDevices.ondevicechange = (e) => {
            this.updateDeviceList();
          };
          this.videoMedia.initRecorder();
        }
      });
    },
    handleGoNext() {
      this.$router.push('/user/devicetest/3');
    },
    handleGoPrev() {
      this.$router.push('/user/devicetest/1');
    },
    handleVideoDeviceChange(e) {
      console.log(e);
      this.videoError = false; // 重新start看看还有没有错误
      const container = document.querySelector('#checkVideo');
      container.innerHTML = '';
      if (this.videoMedia.stream) {
        console.log('stop all the tracks');
        this.videoMedia.stream.getTracks().forEach((track) => {
          track.stop();
        });
        this.stream = null;
      }
      this.options.video.deviceId = e;
      this.start(true);
    },
    updateDeviceList() {
      //TODO:这里的逻辑应该和video的一起抽离出来
      return this.videoMedia
        .getVideoDevices()
        .then((devices) => {
          console.log('receive devices', devices);
          this.devices = devices;
          if (!devices || !Array.isArray(devices) || devices.length === 0) {
            this.currentDevice = '';
          } else {
            this.currentDevice = devices[0].deviceId; //TODO:how to know which deviceid the current track is using
          }
          return devices;
        })
        .catch((err) => {});
    },
  },

  components: {},
  created() {},
  mounted() {

  },
  deactivated() {},
  beforeDestroy() {
    if (this.videoMedia) this.videoMedia.destroy();
  },
  activated() {
    if (this.isActive && !this.videoMedia) { //当前是第二步才初始化摄像头
        this.start();
    }
    if (
      this.videoMedia
      && this.videoMedia.video
      && this.videoMedia.video.paused
    ) {
      this.videoMedia.video.play();
    }
  },
  props: {
    deviceStatus: {
      type: Object,
    },
    checkPassed: {
      type: [Boolean],
    },
  },
  watch: {},
  computed: {
    statusTip() {
      if (this.devices && this.devices.length) {
        return '检测到摄像头';
      }
      if (this.videoError) {
        return '请检查是否正确安装摄像头！以保证考试顺利进行！';
      }
      return '未检测到摄像头，请检查是否正确安装摄像头！以保证考试顺利进行！';
    },
  },
};
</script>
